import { GoTemplateDataProperty } from "./property";
import { DisplayedPropertyType } from "./root";

export class GoTemplateDataImage extends GoTemplateDataProperty{
	displayedName:string = "";
	name:string = "";

	public constructor(url:string, displayedName:{toString():string}){
		super();
		this.name = url;
		this.displayedName = displayedName.toString();
	}

	getNodeType():DisplayedPropertyType {
		return "image";
	}

	getGoTemplateString():string{
		return this.name;
	}
}